<template>
  <dl
    class="appeal-point-block"
    :style="`background: url(${userCommonImageUrlForSp}/bg_stripe_gray.png) repeat top left;`"
  >
    <dt v-if="freeTopic.title">
      {{ freeTopic.title }}
    </dt>
    <dd>
      <img
        v-if="freeTopic.photo"
        :src="getPhotoUrl(freeTopic.photo)"
        class="offer-img-sub image-height-auto"
      >
      <p
        class="pega-pre-wrap"
        v-text="freeTopic.body"
      />
    </dd>
  </dl>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/offer/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'

export default {
  mixins: [jobPreviewCommon],
  props: {
    freeTopic: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
